// src/App.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/Login';  // Login Page 
import AdminDashboard from './pages/Admin/AdminDashboard'; // Admin Dashboard
import CreateUser from './pages/Admin/CreateUser'; // Standalone UserCreator
import SalesDashboard from './pages/Sales/SalesDashboard'; // Sales Dashboard
import AddCustomer from './pages/Sales/AddCustomer';
import EditCustomer from './pages/Sales/EditCustomer'; 
import SearchCustomer from './pages/Sales/SearchCustomer';
import SalesOrderList from './pages/Sales/SalesOrderList';
import CreateSalesOrder from './pages/Sales/CreateSalesOrder';
import SalesJobList from './pages/Sales/SalesJobsList';
import OperationsDashboard from './pages/Operations/OperationsDashboard'; // Operations Dashboard
import JobOrdersList from './pages/Operations/JobOrdersList';
import TeamManagement from './pages/Operations/TeamManagement';
import VehicleMachineryManagement from './pages/Operations/VehicleMachineryManagement';
import AccountsDashboard from './pages/Accounts/AccountDashboard'; // Accounts Dashboard
import HomeScreen from './pages/Home'; // Accounts Dashboard
import ProtectedRoute from './components/PrivateRoute';
import AdminLayout from './layouts/AdminLayout';
import AdminCompletedJobs from './pages/Admin/AdminCompletedJobs'; // ✅ NEW
import AdminJobPerformance from './pages/Admin/JobPerformance';
import AdminTeamAnalytics from './pages/Admin/TeamAnalytics';
import AdminJobDetails from './pages/Admin/AdminJobDetails';

import CILayout from './layouts/CILayout';
import CIDashboard from './pages/CI/CIDashboard';
import AddCIClient from './pages/CI/AddCIClient';
import ListCIClients from './pages/CI/ListCIClients';
import SiteAssignments from './pages/CI/SiteAssignments';
import SitesManagement from 'pages/CI/SiteManagement';
import CommercialTeamManagement from 'pages/CI/TeamManagement';
import TeamSchedulingCalendar from 'pages/CI/TeamSchedulingCalender';
import ClientSiteAssignments from './pages/CI/ClientAssignments';
import CITasksData from './pages/CI/CITasksData'
import JobHistory from 'pages/CI/JobHistory';
import AdminIoT from 'pages/Admin/Admin-IoT';
import CustomerJobHistory from 'pages/CustomerPortal/CustomerJobHistory';
import CustomerPortal from 'pages/CustomerPortal/CustomerDashboard';
import CustomerProfile from 'pages/CustomerPortal/CustomerProfile';
import UserManagement from 'pages/Admin/UserManagement';
import CommercialDashboard from 'pages/Admin/CiDashboard'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CommercialClientList from 'pages/Admin/CommercialClientsList';
import HiringForm from 'pages/Employeeform/EmployeeForm';
import Part2Form from 'pages/Employeeform/EmployeeQuestion';
import EmployeeDashboard from 'pages/Employeeform/EmployeeDashboard';
import NovaDashboard from 'pages/CI/NovaaTracking';
import HiredEmployee from 'pages/Employeeform/HiredEmployee';
import OnBoardingForm from 'pages/Employeeform/NovaOnBoardingForm';



function App() {

  
  return (
    <>
    <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/employee-form" element={<HiringForm />} />
        <Route path="/employee-question-form" element={<Part2Form />} />
        <Route path="/novaa-tracker" element={<NovaDashboard />} />
        <Route path="/hired-employees" element={<HiredEmployee />} />
        <Route path="/employee-dashboard" element={<EmployeeDashboard />} />
        <Route path="/create-user" element={<CreateUser />} />
        <Route element={<AdminLayout />}>
        <Route path="/dashboard/admin" element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/sales" element={
          <ProtectedRoute allowedRoles={['sales']}>
            <SalesDashboard />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/operations" element={
          <ProtectedRoute allowedRoles={['operations']}>
            <OperationsDashboard />
          </ProtectedRoute>
        } />
        <Route path="/dashboard/accounts" element={
          <ProtectedRoute allowedRoles={['accounts']}>
            <AccountsDashboard />
          </ProtectedRoute>
        } />

            <Route path="/dashboard/customer" element={
          <ProtectedRoute allowedRoles={['customer']}>
            <CustomerPortal />
          </ProtectedRoute>
        } />

              <Route path="/dashboard/commercial" element={
          <ProtectedRoute allowedRoles={['ci_admin']}>
            <CIDashboard />
          </ProtectedRoute>
        } />
        <Route path="/home" element={
          <ProtectedRoute allowedRoles={['accounts', 'sales', 'operations', 'admin', 'customer']}>
            <HomeScreen />
          </ProtectedRoute>
        } />
        <Route path="/sales/add-customer" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <AddCustomer />
          </ProtectedRoute>
        } />
        <Route path="/sales/edit-customer/:id" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <EditCustomer />
          </ProtectedRoute>
        } />
        <Route path="/sales/search-customers" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <SearchCustomer />
          </ProtectedRoute>
        } />
        <Route path="/sales/list-sales-orders" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <SalesOrderList />
          </ProtectedRoute>
        } />
        <Route path="/sales/sales-order/create/:id" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <CreateSalesOrder />
          </ProtectedRoute>
        } />
        <Route path="/sales/list-job-orders/" element={
          <ProtectedRoute allowedRoles={['sales', 'admin']}>
            <SalesJobList />
          </ProtectedRoute>
        } />


        <Route path="/operations/list-job-orders" element={
          <ProtectedRoute allowedRoles={['operations', 'admin']}>
            <JobOrdersList />
          </ProtectedRoute>
        } />
        <Route path="/operations/team-management" element={
          <ProtectedRoute allowedRoles={['operations', 'admin']}>
            <TeamManagement />
          </ProtectedRoute>
        } />
        <Route path="/operations/vehicle-machinery-management" element={
          <ProtectedRoute allowedRoles={['operations', 'admin']}>
            <VehicleMachineryManagement />
          </ProtectedRoute>
        } />
         <Route path="/operations/employee-management-form" element={
          <ProtectedRoute allowedRoles={['operations', 'admin']}>
            <HiringForm />
          </ProtectedRoute>
        } />
         <Route path="/operations/employee-management" element={
          <ProtectedRoute allowedRoles={['operations', 'admin']}>
            <EmployeeDashboard />
          </ProtectedRoute>
        } />
        <Route path="/operations/hired-employee" element={
          <ProtectedRoute allowedRoles={['operations', 'admin']}>
            <HiredEmployee />
          </ProtectedRoute>
        } />
        <Route path="/operations/onboarding-form" element={
          <ProtectedRoute allowedRoles={['operations', 'admin']}>
            <OnBoardingForm />
          </ProtectedRoute>
        } />
        <Route path="/admin/completed-job-orders" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminCompletedJobs />
            </ProtectedRoute>
        } />
        <Route path="/admin/job-performance" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminJobPerformance />
            </ProtectedRoute>
        } />
        <Route path="/admin/team-analytics" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminTeamAnalytics />
            </ProtectedRoute>
        } />
        <Route path="/admin/list-clients" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <CommercialClientList />
            </ProtectedRoute>
        } />
        <Route path="/admin/job-details/:id" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminJobDetails />
            </ProtectedRoute>
        } />
         <Route path="/admin/sales-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <SalesDashboard />
            </ProtectedRoute>
        } />
          <Route path="/admin/operations-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <OperationsDashboard />
            </ProtectedRoute>
        } />
           <Route path="/admin/create-user" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <CreateUser />
            </ProtectedRoute>
        } />
           <Route path="/admin/user-management" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <UserManagement />
            </ProtectedRoute>
        } />
           <Route path="/admin/commercial-dashboard" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <CommercialDashboard />
            </ProtectedRoute>
        } />
          <Route path="/admin/iot" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminIoT />
            </ProtectedRoute>
        } />
          <Route path="/reports" element={<div>Reports Page</div>} />
          <Route path="/hr" element={<div>HR Page</div>} />
        </Route>



        {/* CI Module Routes */}
          <Route path="/commercial" element={<CILayout />}>
          <Route index element={<CIDashboard />} /> 
          <Route path="add-clients" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <AddCIClient />
            </ProtectedRoute>
          } />
          <Route path="list-clients" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <ListCIClients />
            </ProtectedRoute>
          } />
                    <Route path="novaa-tracker" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <NovaDashboard />
            </ProtectedRoute>
          } />
          <Route path="site-assignments/:siteId" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <SiteAssignments />
            </ProtectedRoute>
          } />
          <Route path="site-management/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <SitesManagement />
            </ProtectedRoute>
          } />
          <Route path="team-management/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <CommercialTeamManagement />
            </ProtectedRoute>
          } />
          <Route path="team-calender/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <TeamSchedulingCalendar />
            </ProtectedRoute>
          } />
          <Route path="job-history/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <JobHistory />
            </ProtectedRoute>
          } />
          <Route path="client-assignments/" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <ClientSiteAssignments />
            </ProtectedRoute>
          } />
          <Route path="tasks-data" element={
            <ProtectedRoute allowedRoles={['ci_admin']}>
              <CITasksData />
            </ProtectedRoute>
          } />
        </Route>
      

        {/* ============ CUSTOMER PORTAL ROUTES ============ */}
        <Route path="/customer" element={<CILayout />}>
        <Route index element={<CustomerPortal/>} />
          <Route path="job-history/" element={
            <ProtectedRoute allowedRoles={['customer']}>
              <CustomerJobHistory />
            </ProtectedRoute>
          } />
          <Route path="customer-profile/" element={
            <ProtectedRoute allowedRoles={['customer']}>
            <CustomerProfile />
            </ProtectedRoute>
          } />
        </Route>

      </Routes>
      <ToastContainer position='top-right' autoClose={3000} />
      </>
  );
}

export default App;
